const option = (item) => {
  return {
    title: item.label,
    dataIndex: item.value,
  };
};
export const allReportColumns = (options) => options.map(option);
